import React from "react";
import "./index.scss";

const InitialLoader: React.FC = () => {
  return (
    <div className="loader">
      <div className="loader__inner">
        <div className="loader__brand">
          <div className="loader__brand-icon">
            <img
              className="app-header__logo"
              src="/images/qualifyme_light.png"
              alt="QualifyMe"
            />
          </div>
          <h1 className="loader__brand-name">QualifyMe</h1>
        </div>

        <div className="loader__progress">
          <div className="loader__progress-header">
            <span className="loader__progress-label">Initializing System</span>
            {/* <span className="loader__progress-value">65%</span> */}
          </div>
          <div className="loader__progress-bar-track">
            <div className="loader__progress-bar-fill" />
          </div>
          <p className="loader__progress-status">
            Preparing your next big opportunity...
          </p>
        </div>
      </div>

      <div className="loader__decoration">
        <div className="loader__decoration-line" />
      </div>
    </div>
  );
};

export default InitialLoader;
